import { LOADING } from '../constants/storeConstants';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isLoading: true,
};

const loadingSlice = createSlice({
    name: LOADING,
    initialState,
    reducers: {
        setLoading: (state, action) => {
            const { isLoading } = action.payload;
            state.isLoading = isLoading;
        },
    },
});

export const { setLoading } = loadingSlice.actions;

export default loadingSlice.reducer;